// react router
import React, { useNavigate } from "react-router-dom";

// redux
import { useSelector } from "react-redux";

// styles
import Styles from "./kycStatus.module.css";

// icons
import { ReactComponent as LeftArrowIcon } from "../../../../assets/icons/imported/back-arrow.svg";
import { ReactComponent as CheckmarkIcon } from "../../../../assets/icons/imported/checkmark.svg";

// components
import Button from "../../../../components/Button/Button";

// actions
import { _restartKyc } from "../../../../modules/kyc/redux/actions";

function KYCStatus({
  status // verify, verified, pending
}) {
  const navigate = useNavigate()
  console.log("KYC Status:", status)
  const theme = useSelector((state) => state.theme.value)

  // Determine if the KYC button should be disabled
  const isKycInProgress = status === 'sdk_started' || status === 'sdk_completed'

  // Handle KYC verification
  const handleVerifyKyc = () => {
    console.log("Navigating to KYC page using direct location change...")
    // Use direct window location change instead of React Router navigation
    window.location.href = "/kyc"
  }

  // Handle restart KYC
  const handleRestartKyc = () => {
    _restartKyc(
      (data) => {
        // On success, navigate to KYC page
        console.log("KYC restart successful, navigating using direct location change...")
        window.location.href = "/kyc"
      },
      (error) => {
        // Handle error if needed
        console.error("Error restarting KYC:", error)
      }
    )
  }

  return (
    <div
      className={Styles.card}
      style={{
        backgroundColor: theme === "light" && "white"
      }}
    >

      {(status === 'not_started' || status === 'sdk_not_started' || !status) && (
        <>
          <div
            className={Styles.iconContainer}
            style={{
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
          >
            {/* icon */}
            <LeftArrowIcon
              color={"var(--primary-color)"}
              style={{
                transform: "rotateZ(180deg)"
              }}
            />
          </div>

          {/* title */}
          <span
            className={Styles.statusTitle}
            style={{ color: "var(--primary-color)" }}
          >
            START YOUR KYC PROCESS
          </span>

          {/* verify button */}
          <Button
            text="Verify your KYC"
            style={{ width: "fit-content" }}
            onClick={handleVerifyKyc}
          />
        </>
      )}

      {(status === 'sdk_started') && (
        <>
          <div
            className={Styles.iconContainer}
            style={{
              color: "orange",
              fontWeight: "bolder",
              fontSize: 30,
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
          >
            {/* icon */}!
          </div>

          {/* title */}
          <span className={Styles.statusTitle} style={{ color: "orange" }}>
            KYC IN PROGRESS
          </span>

          <span className={Styles.pendingMessage}>
            Your KYC process has been initiated. Please wait for the verification to complete.
          </span>
        </>
      )}

      {status === "verified" && (
        <>
          <div
            style={{
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
            className={Styles.iconContainer}
          >
            {/* icon */}
            <CheckmarkIcon color={"var(--primary-color)"} />
          </div>

          {/* title */}
          <span
            className={Styles.statusTitle}
            style={{ color: "var(--primary-color)" }}
          >
            VERIFIED
          </span>

          {/* verified info container */}
          <div className={Styles.verifiedInfoContainer}>
            <span>
              <div
                style={{
                  backgroundColor: theme === "light" && "var(--secondary-color)"
                }}
                className={Styles.iconContainer}
              >
                {/* icon */}
                <CheckmarkIcon color={"var(--primary-color)"} width={9} />
              </div>
              Personal information
            </span>

            <span>
              <div
                style={{
                  backgroundColor: theme === "light" && "var(--secondary-color)"
                }}
                className={Styles.iconContainer}
              >
                {/* icon */}
                <CheckmarkIcon color={"var(--primary-color)"} width={9} />
              </div>
              Government-issued ID
            </span>

            <span>
              <div
                style={{
                  backgroundColor: theme === "light" && "var(--secondary-color)"
                }}
                className={Styles.iconContainer}
              >
                {/* icon */}
                <CheckmarkIcon color={"var(--primary-color)"} width={9} />
              </div>
              Facial recognition
            </span>
          </div>
        </>
      )}

      {(status === "pending" || status === "sdk_pending") && (
        <>
          <div
            className={Styles.iconContainer}
            style={{
              color: "orange",
              fontWeight: "bolder",
              fontSize: 30,
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
          >
            {/* icon */}!
          </div>

          {/* title */}
          <span className={Styles.statusTitle} style={{ color: "orange" }}>
            VERIFICATION PENDING
          </span>

          <span className={Styles.pendingMessage}>
            Just checking your details and we'll get back to you soon!
          </span>
        </>
      )}

      {(status === "sdk_completed") && (
        <>
          <div
            className={Styles.iconContainer}
            style={{
              color: "orange",
              fontWeight: "bolder",
              fontSize: 30,
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
          >
            {/* icon */}!
          </div>

          {/* title */}
          <span className={Styles.statusTitle} style={{ color: "orange" }}>
            AWAITING ADMIN APPROVAL
          </span>

          <span className={Styles.pendingMessage}>
            Your verification is complete and awaiting final review by an administrator.
          </span>
        </>
      )}

      {(status === "rejected") && (
        <>
          <div
            className={Styles.iconContainer}
            style={{
              color: "red",
              fontWeight: "bolder",
              fontSize: 30,
              backgroundColor: theme === "light" && "var(--secondary-color)"
            }}
          >
            {/* icon */}X
          </div>

          {/* title */}
          <span className={Styles.statusTitle} style={{ color: "red" }}>
            VERIFICATION REJECTED
          </span>

          <span className={Styles.pendingMessage}>
            Some of your documents are rejected. Please check again!
          </span>
          <Button
            text="Restart KYC"
            style={{ width: "fit-content" }}
            onClick={handleRestartKyc}
          />
        </>
      )}
    </div>
  )
}

export default KYCStatus
